import axios from 'axios';
import typeToReducer from 'type-to-reducer';
import { SUCCESS, REQUEST, FAIL } from 'containers/App/configureStore';
import { url } from 'configs/';
const {
  RMS_API_SERVER,
} = url;

const path = 'foundation/cvFieldsReducer';
const FETCH_CV_FIELDS = `${path}FETCH_CV_FIELDS`;

const initialState = {
  datas: [],
  isFetching: false,
};

export default typeToReducer({
  [FETCH_CV_FIELDS]: {
    [REQUEST]: (state) => {
      return Object.assign({}, state, {
        isFetching: true,
      });
    },
    [SUCCESS]: (state, action) => {
      const actionData = action.payload.data.data;
      return Object.assign({}, state, {
        datas: actionData,
        isFetching: false,
      });
    },
    [FAIL]: (state) => {
      return Object.assign({}, state, {
        isFetching: false,
      });
    },
  },
}, initialState);

export function fetchCVFields() {
  return {
    type: FETCH_CV_FIELDS,
    payload: axios.get(`${RMS_API_SERVER}cvFields`),
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/reducers/cvFieldsReducer.js
 **/